<div class="row">
  <div class="col-lg-12 personal-results-header">
    <ul class="participant-tabs">
      <li
        class="col-lg-2"
        (click)="selectUser(session.me)"
        [ngClass]="{ active: selectedUser._id === session.me._id }">
        <i class="fa fa-user" aria-hidden="true"></i>

        <strong>{{ session.me['user'].name }}</strong>
      </li>
      <ng-container *ngFor="let participant of session.config.participants">
        <li
          class="col-lg-2"
          *ngIf="
            participant._id !== session.me._id &&
            participant.team === session.me.team
          "
          (click)="selectUser(participant)"
          [ngClass]="{ active: selectedUser._id === participant._id }">
          <i class="fa fa-user" aria-hidden="true"></i>
          <strong>{{ participant.user.name }}</strong>
        </li>
      </ng-container>
    </ul>
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <h3 *ngIf="selectedUser === session.me">
        Your performance
        <!-- this week (vs. last week)-->
      </h3>
      <h3 *ngIf="selectedUser !== session.me">
        {{ selectedUser['user'].name }}'s performance
        <!-- this week (vs. last week)-->
      </h3>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-1"
      *ngIf="selectedUser['privacy'].top_scorer || selectedUser === session.me">
      <div class="chart-container">
        <!-- <div class="chart-bar last-week-bar" style="height:{{playerCreativity}};"></div>-->
        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Performance Score">
          <div
            class="chart-bar this-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].topscorer.performance,
            }"></div>
        </div>
      </div>
      <strong>Top-Scorer</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-topscorer"
            [(ngModel)]="session.me.privacy.top_scorer" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-2"
      *ngIf="
        selectedUser['privacy'].spark_creator || selectedUser === session.me
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerWildness}};"></div>-->
        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Performance Score">
          <div
            class="chart-bar this-week-bar"
            [ngStyle]="{
              height:
                calculatedScores[selectedUser._id].sparkcreator.performance,
            }"></div>
        </div>
      </div>
      <strong>Spark-Creator</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-sparkcreator"
            [(ngModel)]="session.me.privacy.spark_creator" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-3"
      *ngIf="selectedUser['privacy'].improver || selectedUser === session.me">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerImprovement}};"></div>-->
        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Performance Score">
          <div
            class="chart-bar this-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].improver.performance,
            }"></div>
        </div>
      </div>
      <strong>Improver</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-improver"
            [(ngModel)]="session.me.privacy.improver" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-4"
      *ngIf="
        (selectedUser['privacy'].challenger || selectedUser === session.me) &&
        session.config.benefits_and_challenges
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerChallenge}};"></div>-->
        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Performance Score">
          <div
            class="chart-bar this-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].challenger.performance,
            }"></div>
        </div>
      </div>
      <strong>Challenger</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-challenger"
            [(ngModel)]="session.me.privacy.challenger" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-5"
      *ngIf="
        (selectedUser['privacy'].sunshine || selectedUser === session.me) &&
        session.config.benefits_and_challenges
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerPotential}};"></div>-->
        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Performance Score">
          <div
            class="chart-bar this-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].sunshine.performance,
            }"></div>
        </div>
      </div>
      <strong>Sunshine</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-sunshine"
            [(ngModel)]="session.me.privacy.sunshine" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-6"
      *ngIf="
        (selectedUser['privacy'].solution_finder ||
          selectedUser === session.me) &&
        session.config.benefits_and_challenges &&
        session.config.solutions
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerPotential}};"></div>-->
        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Performance Score">
          <div
            class="chart-bar this-week-bar"
            [ngStyle]="{
              height:
                calculatedScores[selectedUser._id].solutionfinder.performance,
            }"></div>
        </div>
      </div>
      <strong>Solution-Finder</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-solutionfinder"
            [(ngModel)]="session.me.privacy.solution_finder" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <h3 *ngIf="selectedUser === session.me">
        Your activity
        <!-- this week (vs. last week)-->
      </h3>
      <h3 *ngIf="selectedUser !== session.me">
        {{ selectedUser['user'].name }}'s activity
        <!-- this week (vs. last week)-->
      </h3>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-1"
      *ngIf="selectedUser['privacy'].top_scorer || selectedUser === session.me">
      <div class="chart-container">
        <!-- <div class="chart-bar last-week-bar" style="height:{{playerCreativity}};"></div>-->

        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Activity Score">
          <div
            class="chart-bar last-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].topscorer.activity,
            }"></div>
        </div>
      </div>
      <strong>Top-Scorer</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-activity-topscorer"
            [(ngModel)]="session.me.privacy.top_scorer" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-2"
      *ngIf="
        selectedUser['privacy'].spark_creator || selectedUser === session.me
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerWildness}};"></div>-->

        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Activity Score">
          <div
            class="chart-bar last-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].sparkcreator.activity,
            }"></div>
        </div>
      </div>
      <strong>Spark-Creator</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-activity-sparkcreator"
            [(ngModel)]="session.me.privacy.spark_creator" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-3"
      *ngIf="selectedUser['privacy'].improver || selectedUser === session.me">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerImprovement}};"></div>-->

        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Activity Score">
          <div
            class="chart-bar last-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].improver.activity,
            }"></div>
        </div>
      </div>
      <strong>Improver</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-activity-improver"
            [(ngModel)]="session.me.privacy.improver" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-4"
      *ngIf="
        (selectedUser['privacy'].challenger || selectedUser === session.me) &&
        session.config.benefits_and_challenges
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerChallenge}};"></div>-->

        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Activity Score">
          <div
            class="chart-bar last-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].challenger.activity,
            }"></div>
        </div>
      </div>
      <strong>Challenger</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-activity-challenger"
            [(ngModel)]="session.me.privacy.challenger" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-5"
      *ngIf="
        (selectedUser['privacy'].sunshine || selectedUser === session.me) &&
        session.config.benefits_and_challenges
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerPotential}};"></div>-->

        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Activity Score">
          <div
            class="chart-bar last-week-bar"
            [ngStyle]="{
              height: calculatedScores[selectedUser._id].sunshine.activity,
            }"></div>
        </div>
      </div>
      <strong>Sunshine</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            name="privacy-activity-sunshine"
            [(ngModel)]="session.me.privacy.sunshine" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
    <div
      class="col-lg-2 chart-group chart-group-6"
      *ngIf="
        (selectedUser['privacy'].solution_finder ||
          selectedUser === session.me) &&
        session.config.benefits_and_challenges &&
        session.config.solutions
      ">
      <div class="chart-container">
        <!--<div class="chart-bar last-week-bar" style="height:{{playerPotential}};"></div>-->

        <div
          class="chart-bar wrapper"
          placement="top"
          [hide-delay]="100"
          tooltip="Activity Score">
          <div
            class="chart-bar last-week-bar"
            [ngStyle]="{
              height:
                calculatedScores[selectedUser._id].solutionfinder.activity,
            }"></div>
        </div>
      </div>
      <strong>Solution-Finder</strong>
      <div class="switch-container" *ngIf="selectedUser._id === session.me._id">
        <label style="padding-top: 15px; font-weight: normal">
          <input
            type="checkbox"
            [(ngModel)]="session.me.privacy.solution_finder" />
          Published
        </label>
        <!--
          <i class="fa fa-2x muted fa-eye-slash" aria-hidden="true" tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Hide this bar for me and others"></i>
          <switch ng-click=""
                  name="enabled" ng-model="idea.mature" class="green"></switch>
          <i class="fa fa-2x muted fa-eye" aria-hidden="true"tooltips tooltip-size="small" tooltip-side="bottom" tooltip-template="Show this bar to me and others"></i>
          -->
      </div>
    </div>
  </div>
  <div class="row" *ngIf="selectedUser._id === session.me._id">
    <button class="btn btn-primary">Save Privacy Settings</button>
  </div>

  <!--
    <div class="element">
      <div class="col-lg-12">
        <h3>Badges you have been awarded</h3>
      </div>
    </div>

    <div class="element">
      <div class="col-lg-12">
        <h3>See what your role colleagues are doin</h3>
      </div>
    </div>
  -->
</div>
